<template lang="pug">
  .Home
    .container-fluid.p-0
        .jumbotron.Home-background
          .container
            h1.Home-headline Christoph Schommer
            h3.Home-subheadline Rechtsanwalt
            h3.Home-subheadline Fachanwalt für Bau- und Architektenrecht
    .container-fluid.Profile
      .container.Profile-wrapper
        .col-md-4.Profile-image
          img(src='@/assets/rechtsanwalt-christoph-schommer.jpg')
        .col-md-8.Profile-text
          p Rechtsanwalt Christoph Schommer wurde 1959 in Saarbrücken geboren und war von 1988 an und ab 1993 als Partner der Sozietät Behr Lachmann Neixler & Partner GbR tätig. Seit Januar 2006 ist er Fachanwalt für Bau- und Architektenrecht.
          p Nach Auflösung der BLN & Partner GbR zum 31.12.2018 war Rechtsanwalt Schommer als Einzelanwalt in einer Steglitzer Bürogemeinschaft weiterhin vornehmlich in Bau- und Architektenangelegenheiten tätig.
          p Seit 01.01.2023 übt er nunmehr seine Anwaltstätigkeit in einer neuen Bürogemeinschaft in der Albestraße 21, 12159 Berlin in enger Kooperation mit Rechtsanwalt Jae-Yoon Lee aus, der ihn auch entsprechend bei Abwesenheiten vertreten wird.
          p
            | RA Schommer ist seit 1993 Mitglied der Arbeitsgemeinschaft für Baurecht und Immobilien 
            a(href='https://www.arge-baurecht.com/') ARGE Baurecht
            | &nbsp;im Deutschen Anwaltsverein.
    .container.Home-content
      .Home-content-wrapper
        router-link.Home-content-item( :to="{ name: 'Baurecht' }" tag='a')
          .Home-content-icon
            i.fa.fa-2x.fa-home
          h4 Privates Baurecht
          p.Home-content-description Das <b>private oder zivile Baurecht</b> betrifft die Rechtsbeziehungen der Baubeteiligten untereinander.
        router-link.Home-content-item( :to="{ name: 'Architektenrecht' }" tag='a')
          .Home-content-icon
            i.fa.fa-2x.fa-building
          h4 Architektenrecht
          p.Home-content-description Vertragsentwürfe über Architektenleistungen für alle Arten von Bauvorhaben.
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="stylus" scoped>
  .Home {

    &-headline {
      font-size 48px
      color $white

      +below('m') {
        font-size 30px
      }
    }

    &-subheadline {
      color #eee

      +below('m') {
        font-size 20px
      }
    }

    &-background {
      min-height 30vh
      margin-bottom 0

      background-image url('../assets/header-banner.jpg')
      background-repeat no-repeat
      background-position center -30px
      background-size cover
      border-radius 0

      +below('m') {
        background-position center

        .container {
          padding 1em

          background-color rgba(0, 0, 0, .5)
          border-radius 5px
        }
      }
    }

    .Profile {
      padding 4em 2em
      background-color $secondary
      color $white

      +below('m') {
        padding 2em 1em
      }

      &-wrapper {
        display flex
        flex-direction row
        justify-content center

        +below('m') {
          flex-wrap wrap
          padding 0
        }
      }

      &-image {
        +below('m') {
          margin-bottom 1.5em

          img {
            max-width 200px
          }
        }
      }

      &-text {
        max-width 400px
        text-align left
      }
    }

    &-content {
      padding 2em
      margin-top 2em
      
      +below('m') {
        padding 1em
        margin-top 0
      }

      &-wrapper {
        display flex
        flex-direction row
        justify-content center
        max-width 1000px
        margin auto

        +below('m') {
          flex-direction column
        }
      }

      &-icon {
        margin 0 auto 1em
        width 65px
        height @width
        display flex
        justify-content center
        align-items center

        background-color $primary--dark
        border-radius 50%

        .fa-building {
          margin-left 3px
        }

        .fa-balance-scale {
          margin-left 2px
        }
      }

      &-item {
        width 50%
        padding 2em
        margin-right 1em

        background-color $secondary
        border-radius 5px
        box-shadow 2px 2px 5px 0px #555
        transition all .5s
        
        color $secondary-text

        +below('m') {
          margin-right 0
          margin-top 1em
          width auto
        }

        &:last-child {
          margin-right 0  
        }

        &:hover {
          background-color $secondary--light
          box-shadow 3px 3px 5px 0px #555
          cursor pointer
          text-decoration none  
        }
      }

      &-description {
        margin-top 1em
        font-size 14px
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Startseite.vue